module.exports = __webpack_public_path__ + "img/4cb4f18f09c6054826c3ce660752204f.png";